





























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { goToWebinar } from "@/plugins/go-to";
import { BBBRecord as IBBBRecord } from "@/api/models/bbbrecord";
import api from "@/getinfo-api";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTable from "@/components/form/CustomTable.vue";

@Component({
  components: {
    CustomButton,
    CustomTableCol,
    CustomTableItem,
    CustomTable
  }
})
export default class webinarListItemTable extends Vue {
  @Prop() webinar!: IWebinar;
  @Prop() accessTokenDev?: any;
  @Prop() accessTokenProd?: any;
  bbbRecord?: Array<IBBBRecord>;
  isGettingWebinarSpinner: boolean = false;
  isNotFoundWebinar: boolean = false;

  data() {
    return {
      webinarTeacher: undefined,
      viewersCount: undefined,
      bbbRecord: undefined
    };
  }

  lengthFilter(length: string) {
    if (length.length > 40) {
      return length.slice(0, 60);
    } else {
      return length;
    }
  }

  get isExistBBBWebinar() {
    return !!this.bbbRecord?.length;
  }

  get isAccessRolesToWebinarRecord() {
    return this.webinarOwner || this.webinarCompanyOwner || this.root;
  }

  info() {
    this.$bvToast.toast(
      `${this.$tc(this.$translate.EntriesAreDeletedAfterDays)}`,
      {
        title: this.$tc(this.$translate.Warning),
        variant: "warning"
      }
    );
  }

  getTimeAccess() {
    if (this.webinar.status === "running") {
      this.goToWebinarLink();
    }

    if (this.webinar.status === "coming") {
      if (this.availableNotStartedWebinar) {
        this.goToWebinarLink();
      } else {
        this.$bvToast.toast(
          `${this.$tc(
            this.$translate.YouCanEnterTheWebinarRoomOnlyMinutesBeforeTheStart
          )}`,
          {
            variant: "danger",
            title: this.$tc(this.$translate.Error)
          }
        );
      }
    }

    if (this.webinar.status === "finished") {
      this.$bvToast.toast(this.$tc(this.$translate.Ended), {
        variant: "danger",
        title: `${this.$tc(this.$translate.Error)}`
      });
    }
  }

  get availableNotStartedWebinar() {
    let result = false;
    if (this.webinar.status === "coming") {
      let started = new Date(this.webinar.startedAt).getTime();
      let tenMinutes = started - 600000;
      let now = new Date().getTime();
      if (now < started && now >= tenMinutes) {
        result = true;
      }
    }
    return result;
  }

  goToPlaybackWebinar(route: string) {
    let playbackWebinar = document.createElement("a");
    playbackWebinar.href = route;
    playbackWebinar.target = "_blank";
    playbackWebinar.click();
  }

  goToDeskShareVideoUrl(route: string) {
    let deskShareVideoUrl = document.createElement("a");
    deskShareVideoUrl.href = route;
    deskShareVideoUrl.target = "_blank";
    deskShareVideoUrl.click();
  }

  goToWebcamVideoUrl(route: string) {
    let webcamVideoUrl = document.createElement("a");
    webcamVideoUrl.href = route;
    webcamVideoUrl.target = "_blank";
    webcamVideoUrl.click();
  }

  goToDownloadUrl(route: string) {
    let downloadUrl = document.createElement("a");
    downloadUrl.href = route;
    downloadUrl.target = "_blank";
    downloadUrl.click();
  }

  get ownerWebinar() {
    return this.webinar.ownerId === this.userId;
  }

  getBBBRecord() {
    this.isGettingWebinarSpinner = true;
    api.BBBWebinarApi.getRecordings(this.webinar.id)
      .then((res: { data: Array<IBBBRecord> }) => {
        this.bbbRecord = res.data;
        if (!this.bbbRecord.length) {
          this.isNotFoundWebinar = true;
        }
      })
      .catch(() => {
        this.isNotFoundWebinar = true;
      })
      .finally(() => {
        this.isGettingWebinarSpinner = false;
      });
  }

  goToWebinarLink() {
    goToWebinar(this.webinar.id, this.token);
  }

  get canEdit() {
    return this.root || this.webinarCompanyOwner || this.webinarOwner;
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany;
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get webinarOwner() {
    return this.webinar.ownerId === this.userId;
  }

  get webinarCompanyOwner() {
    let result: boolean = false;
    if (this.selectedCompany.id === this.webinar.companyId) {
      if (this.selectedCompany.owner.id === this.userId) {
        result = true;
      }
    }
    return result;
  }

  get styleForWebinarStatus() {
    let name = "";
    if (this.webinar.status === "coming") name = "webinar_coming-table";
    if (this.webinar.status === "running") name = "webinar_running-table";
    if (this.webinar.status === "finished") name = "webinar_finished-table";
    return name;
  }

  get webinarStatus() {
    let webinarStatus: string = "";
    if (this.webinar.status === "coming")
      webinarStatus = this.$tc(this.$translate.WebinarNotStarted);
    if (this.webinar.status === "running")
      webinarStatus = this.$tc(this.$translate.Online);
    if (this.webinar.status === "finished")
      webinarStatus = this.$tc(this.$translate.Ended);
    return webinarStatus;
  }

  get token() {
    let dev = localStorage.getItem("auth-tokens-development");
    let prod = localStorage.getItem("auth-tokens-production");

    const parsed = {
      prod: prod ? JSON.parse(prod) : undefined,
      dev: dev ? JSON.parse(dev) : undefined
    };

    return parsed.prod ? parsed.prod.accessToken : parsed.dev.accessToken;
  }
}
